import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { IMPERSONATION_HASH_KEY } from '@dimmi/shared';

import App from './App.vue';
import { setImpersonationToken } from './lib/api';
import { router } from './router';

import './styles/tokens.css';
import './styles/reset.css';

// An impersonation tab is opened with the bearer token in the URL hash
// (`#imp=…`) — fragments never reach the server, never get logged. Park it in
// this tab's sessionStorage and scrub the URL before the router hydrates.
function captureImpersonationToken(): void {
  const hash = window.location.hash;
  if (!hash.startsWith('#')) return;
  const token = new URLSearchParams(hash.slice(1)).get(IMPERSONATION_HASH_KEY);
  if (!token) return;
  setImpersonationToken(token);
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
captureImpersonationToken();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
